import React, { useContext, useEffect, useState } from "react";
import { createTheme } from "@mui/material";
import { Button } from "@mui/material";
import { ThemeProvider } from "@mui/material";
import ActionTable from "../../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import Form from "../../../components/form";

export default function Videos({ unidadeId }) {
  const [carregando, setCarregando] = useState(false);
  const [listaVideos, setListaVideos] = useState([]);
  const [novoVideo, setNovoVideo] = useState(false);
  const [videoSelecionado, setVideoSelecionado] = useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    listarVideos();
  }, []);

  const listarVideos = () => {
    setCarregando(true);

    api
      .get("unidades/listarVideos", { unidadeId })
      .then((videos) => {
        setListaVideos(videos);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Erro ao listar os vídeos");
        setCarregando(false);
      });
  };

  const abrirVideo = (registro) => {
    setVideoSelecionado(registro);
  };

  const salvarVideo = (video) => {
    video.unidadeId = unidadeId;

    if (videoSelecionado.id > 0) {
      video.id = videoSelecionado.id;
      api
        .post("unidades/editarVideo", video)
        .then((res) => {
          notification("success", "Video salvo!");
          setNovoVideo(false);
          setVideoSelecionado({});
          listarVideos();
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Referência inválida");
            case 2:
              return notification("error", "Título inválido");
            case 3:
              return notification("error", "Unidade inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("unidades/inserirVideo", video)
        .then((res) => {
          notification("success", "Video salvo!");
          setNovoVideo(false);
          setVideoSelecionado({});
          listarVideos();
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Referência inválida");
            case 2:
              return notification("error", "Título inválido");
            case 3:
              return notification("error", "Unidade inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const removerVideo = () => {
    api
      .delete("unidades/removerVideo", {
        videoId: videoSelecionado.id,
      })
      .then((res) => {
        notification("warning", "Video removido");
        setNovoVideo(false);
        setVideoSelecionado({});
        listarVideos();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Referência inválida");
          case 2:
            return notification("error", "Título inválido");
          case 3:
            return notification("error", "Unidade inválida");
          default:
            return notification("error", "Erro ao remover o video");
        }
      });
  };

  const tRegistros = {
    title: "Vídeos da Unidade",
    onLineClick: abrirVideo,
    columns: [
      {
        name: "titulo",
        label: "Titulo",
      },
      {
        name: "ordem",
        label: "Ordem",
      },
      {
        name: "titulo",
        label: "Categoria",
        // domain: videoCategoria
      },
      {
        name: "disponivelProfissionais",
        label: "Profissionais",
        checkbox: true,
      },
      {
        name: "disponivelPais",
        label: "Pais",
        checkbox: true,
      },
    ],
    array: listaVideos,
  };

  const filtros = {
    form: {
      referencia: {
        label: "ID do vídeo",
        type: "text",
        value: videoSelecionado.referencia,
        space: 3,
        required: true,
      },
      titulo: {
        label: "Título",
        type: "text",
        value: videoSelecionado.titulo,
        space: 7,
      },
      ordem: {
        label: "Ordem",
        type: "number",
        value: videoSelecionado.ordem,
        space: 2,
      },

      categoria: {
        label: "Categoria",
        type: "select",
        value: videoSelecionado.categoria,
        emptyItem: true,
        space: 4,
        options: [
          {
            value: 1,
            desc: "Treinamento",
          },
          {
            value: 2,
            desc: "História",
          },
          {
            value: 3,
            desc: "Cantiga",
          },
          {
            value: 4,
            desc: "Aula",
          },
          {
            value: 5,
            desc: "Libras",
          },
        ],
      },

      disponivelProfissionais: {
        label: "Disponível para profissionais",
        type: "check",
        value: videoSelecionado.disponivelProfissionais,
        space: 4,
      },
      disponivelPais: {
        label: "Disponível para pais",
        type: "check",
        value: videoSelecionado.disponivelPais,
        space: 4,
      },
    },

    submit: {
      label: "Salvar",
      action: salvarVideo,
    },
    close: {
      label: "Fechar",
      action: () => {
        setNovoVideo(false);
        setVideoSelecionado({});
      },
    },

    customActions:
      videoSelecionado.id > 0
        ? [
            {
              label: "Remover",
              action: () => removerVideo(),
            },
          ]
        : undefined,
  };

  return (
    <div>
      {novoVideo || videoSelecionado.id > 0 ? (
        <>{carregando ? <CircularProgress /> : <Form formData={filtros} />}</>
      ) : (
        <>
          <ThemeProvider theme={theme}>
            <Button
              style={{ margin: "0px 10px 0px 10px" }}
              variant="contained"
              sx={{ color: "#FFFF" }}
              onClick={() => setNovoVideo(true)}
            >
              +
            </Button>
          </ThemeProvider>
          <br />
          <br />
          {carregando ? (
            <CircularProgress />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      )}
    </div>
  );
}
const theme = createTheme({
  palette: {
    primary: {
      main: "#fa9702",
      color: "white",
    },
  },
});
